import http from '@/services';
import router from '@/router';
import { encryptAES } from '@/utils';

const loginModule = {
  namespaced: true,

  state() {
    return {};
  },

  mutations: {},

  actions: {
    async login({ commit }, payload) {
      const res = await http.login.userLogin(payload);
      if (res.state === '11') {
        sessionStorage.setItem('token', encryptAES(res.user.sessionId));
        // sessionStorage.setItem('sessionId', encryptAES(res.user.sessionId));
        // sessionStorage.setItem('isLogin', true);
        sessionStorage.setItem('user', encryptAES(JSON.stringify(res.user)));

        const { ingenicoType } = res.user;
        if (ingenicoType !== 1) {
          commit(
            'setState',
            {
              state: 'isLogin',
              values: true,
            },
            {
              root: true,
            },
          );
          sessionStorage.setItem('isLogin', true);
        }

        commit(
          'setState',
          {
            state: 'userInfo',
            values: res.user,
          },
          {
            root: true,
          },
        );
        if (res.visaCardType) {
          sessionStorage.setItem('visaCardType', res.visaCardType);
          commit(
            'setState',
            {
              state: 'visaCardType',
              values: res.visaCardType,
            },
            {
              root: true,
            },
          );
        }
      }
      return res;
    },

    async logout({ rootState, commit }, payload) {
      const { userId, sessionId } = rootState.userInfo;
      const res = await http.login.userLogout({ userId, sessionId });
      if (res.state === '11') {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('isLogin');
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('afterLoginRouter');
        sessionStorage.removeItem('searchItem');
        sessionStorage.removeItem('vcesStatus');
        sessionStorage.removeItem('visaCardType');
        sessionStorage.removeItem('userContactToken');
        commit('setHeaderBankLogo', null, {
          root: true,
        });
        commit(
          'setState',
          {
            state: 'isLogin',
            values: false,
          },
          {
            root: true,
          },
        );

        commit(
          'setState',
          {
            state: 'userInfo',
            values: null,
          },
          {
            root: true,
          },
        );
        commit(
          'setState',
          {
            state: 'vcesStatus',
            values: null,
          },
          {
            root: true,
          },
        );
        commit(
          'setState',
          {
            state: 'visaCardType',
            values: null,
          },
          {
            root: true,
          },
        );
        if (!(payload && payload.noJump)) {
          router.push({ path: '/' });
        }
        // router.push('/');
        // location.reload();
      } else {
        console.error(res.note);
      }
    },
  },
};

export default loginModule;
